<template>
  <div class="is-height-100p">
    <div>
      <AppHeader :key="monSite" :monSite = "monSite" />
    </div>
    <div class="columns is-marginless" v-if="dataLoad">
      <div class="column is-9 pl-20 pt-20 pr-20 is-relative" style="padding-top: 100px;">
        <BlocProduits/>
      </div>
      <div class="column is-3 is-fixe is-offset-9 pt-20 pl-0 pr-20 is-hidden-touch" style="padding-top: 100px;">
        <BlocInfos/>
      </div>
    </div>
    <div class=" column is-marginless is-hidden-desktop">
      <BlocInfosMobile/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import Header from '@/components/general/Header';
import BlocInfos from '@/components/portail/BlocInfos';
import BlocInfosMobile from '@/components/portail/BlocInfosMobile';
import BlocProduits from '@/components/portail/BlocProduits';
import * as types from '@/store/modules/user-mutation-type';

const Recommandation = createNamespacedHelpers('recommandation');
const User = createNamespacedHelpers('user');


export default {
  components: {
    AppHeader: Header,
    BlocInfos,
    BlocProduits,
    BlocInfosMobile,
  },
  data: () => ({
    dataLoad: false,
    monSite: "",
  }),
  methods: {
    ...User.mapMutations({
      setSite: types.SET_SITE,
    }),
    ...Recommandation.mapActions({
      actionsGetRecom: 'getRecom',
    }),
    async load() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        var retour = await this.actionsGetRecom(this.$route.params.id);
        // retour.societe.nom === 'Havas' ? this.setSite('havas') :this.setSite('aa') ;
        // retour.societe.nom === 'Havas' ? this.monSite ='havas' :this.monSite ='aa' ;
        this.monSite = retour.societe.nom;
        loadingComponent.close();
        this.dataLoad = true;
      } catch (e) {
        loadingComponent.close();
        gestionErreur('Erreur serveur');
      }
    },
  },
  async mounted() {
    await this.load();
  },
};
</script>

<style>

</style>